import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SectionA from './Components/SectionA';
import { useNavigate } from "react-router-dom"
// import Features from './Components/Features/Features';
import Footer from '../../GlobalComp/Footer/Footer';
// import Faq from './Components/Faq/Faq';
// import HowItWorks from './Components/HowItWorks/HowItWorks';
// import Locations from './Components/Locations/Locations';
import Membership from './Components/Membership/Membership';
// import Testimonials from './Components/Testimonials/Testimonials';
import SEO from '../../../seo/SEO';
import { SITE_URL } from '../../../seo/config';
import StoryMission from './Components/StoryMission/StoryMission';

function Home() {
  const navigateTo = useNavigate();

  const scrollToElement = (elementId) => {
    const targetElement = document.getElementById(elementId);

    if (targetElement) {
      const offset = 0;
      const targetPosition = targetElement.offsetTop + offset;

      window.scroll({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  };
  const location = useLocation();

  useEffect(() => {
    const scrollInfo = location?.state?.scrollTo;
    if (scrollInfo) {
      setTimeout(() => {
        scrollToElement(scrollInfo.id, scrollInfo.offset);

        navigateTo(location.pathname, { replace: true, state: {} });
      }, 100);
    }
  }, [location.state]);

  // For SEO only
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Fuel Clubs",
    "url": SITE_URL,
    "logo": `${SITE_URL}/logo.png`
  };

  const service = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "On-demand fuel delivery",
    "provider": { "@type": "Organization", "name": "Fuel Clubs" },
    "areaServed": { "@type": "City", "name": "Las Vegas" },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Memberships",
      "itemListElement": [
        {
          "@type": "Offer",
          "name": "Basic",
          "priceCurrency": "USD",
          "price": 50,
          "description": "No vehicle limit, 10 fill-ups per month, fuel at cost, $10 setup fee"
        },
        {
          "@type": "Offer",
          "name": "Premium",
          "priceCurrency": "USD",
          "price": 100,
          "description": "3 vehicles, unlimited fill-ups, fuel at cost, $10 setup fee"
        },
        {
          "@type": "Offer",
          "name": "Fleet",
          "priceCurrency": "USD",
          "price": 50,
          "priceSpecification": {
            "@type": "UnitPriceSpecification",
            "priceCurrency": "USD",
            "price": 50,
            "unitCode": "EACH" // per vehicle
          },
          "description": "Unlimited fill-ups, fuel at cost, $199 setup fee, $12.95 remote fee (waived over 10 vehicles)"
        }
      ]
    }
  };

  // In /src/MainWebsite/Pages/Home/Home.jsx (or wherever your Home is)
  const faq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How does a Fuel Clubs membership work?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "With a Fuel Clubs membership, you can schedule fuel deliveries directly to your home or business. Simply choose a plan, request a delivery through our app or website, and our team will arrive to refuel your vehicle or equipment on your scheduled day — no trips to the gas station needed."
        }
      },
      {
        "@type": "Question",
        "name": "What types of fuel do you deliver?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "We deliver regular (87), Diesel , and premium (91–93) gasoline directly to your vehicle or equipment."
        }
      },
      {
        "@type": "Question",
        "name": "How often can I schedule deliveries?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can schedule deliveries whenever you need them—whether it’s planned in advance or a last-minute request."
        }
      },
      {
        "@type": "Question",
        "name": "Is there an additional fee for same-day delivery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No, there’s no extra fee for same-day deliveries."
        }
      },
      {
        "@type": "Question",
        "name": "Can I pause or cancel my membership?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely. You can pause your membership anytime without penalty, and you’re free to cancel whenever you choose. No hidden fees or long-term commitments."
        }
      }
    ]
  };

  return (
    <>
      <SEO
        title="Fuel Clubs | On-Demand Fuel Delivery in Las Vegas"
        description="Convenient, reliable fuel delivery so you never have to stop for gas again. Schedule online, track in real time, and get fuel delivered to your home, office, or job site in Las Vegas."
        keywords={[
          'fuel delivery Las Vegas',
          'mobile gas delivery',
          'on-demand fuel',
          'fleet fueling',
          'Fuel Clubs membership',
          'schedule fuel delivery',
          'track fuel delivery'
        ]}
        robots="index, follow"
        canonical="/"
        image="/logo.png"
        type="website"
        structuredData={[organization, service, faq]}
      />

      <div>
        <SectionA />
        {/* <Features /> */}
        {/* <HowItWorks /> */}
        {/* <Locations /> */}
        {/* <Testimonials /> */}
        <Membership />
        <StoryMission />
        {/* <Faq /> */}
        {/* <Footer /> */}
      </div>
    </>
  );
}

export default Home;
